getUserEmailPreferencesById